/**
 * Data Table  component state
 *
 * @package ext-components-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ISchemaConstObject, TGetBlueprintSchemaSpec } from "@adapptio/lib-blueprint";
import { TTableItemIds } from "../Table/types";
import { ComponentDataTable_Props } from "./props";

export type TResolvedItemValue = string | number | boolean;

export type TResolvedItemData = {
	[K: string]: {
		value: TResolvedItemValue;
		formattedValue?: string;
	};
};

export enum DATA_TABLE_RESOLVED_ITEM_STATE {
	UNEDITED = "unedited",
	EDITED_BY_USER = "edited-by-user",
	EDITED_BY_COMPONENT = "edited-by-component"
}

export interface IResolvedItem {
	id: string;
	data: TResolvedItemData;
	originalData: unknown;
	state: DATA_TABLE_RESOLVED_ITEM_STATE;
}

export interface IPagination {
	limit: number;
	page: number;
	maxDisplayedPages: number;
	typeData: TGetBlueprintSchemaSpec<
		ISchemaConstObject<typeof ComponentDataTable_Props>
	>["pagination"]["typeData"];
}

export interface ISort {
	key?: string;
	order: string;
	client: boolean;
}

export interface ComponentDataTable_State {
	items: unknown[];

	resolvedItems: IResolvedItem[];

	totalItems: number;

	order: TTableItemIds;

	pageOrder: TTableItemIds;

	pagination?: IPagination;

	specPagination?: IPagination;

	sort?: ISort;

	specSort?: ISort;

	setPage?: (page: number) => void;
}
